import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ProductRecommendationModel } from "@insite/client-framework/Services/ProductRecommendationsService";
import log from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/Log";
import { chain, SetTrack } from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareTrack";
import { peeriusSiteName } from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

type HandlerType = Handler<{ prepareTrackData: ProductRecommendationModel }>;

export const GerrieSetTrack: HandlerType = async ({ getState, dispatch, parameter: { prepareTrackData } }) => {
    const track = { ...prepareTrackData, site: peeriusSiteName(getState()) };
    const { billToId } = getSession(getState());
    if (billToId) {
        await waitFor(() => getBillToState(getState(), billToId).value !== undefined);
    }
    const currentBillTo = getBillToState(getState(), billToId);
    const customerType = currentBillTo?.value?.properties.customerType || "";
    Object.assign(track.customAttributes, {
        brand: customerType
    });
    dispatch(log({ message: "Prepare Track: ", data: track }));
    window.PeeriusCallbacks.track = track;
};

replaceInChain(chain, SetTrack, GerrieSetTrack);